import api from './api';
import { Ware, CreateWareRequest, UpdateWareRequest } from '../types';

export const wareService = {
  getAll: async (): Promise<Ware[]> => {
    const response = await api.get('/waren');
    return response.data;
  },

  getById: async (id: number): Promise<Ware> => {
    const response = await api.get(`/waren/${id}`);
    return response.data;
  },

  create: async (data: CreateWareRequest): Promise<Ware> => {
    const response = await api.post('/waren', data);
    return response.data;
  },

  update: async (id: number, data: UpdateWareRequest): Promise<Ware> => {
    const response = await api.put(`/waren/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/waren/${id}`);
  },
};

export default wareService;
